import { createAsyncThunk } from '@reduxjs/toolkit';

import * as questionSetsService from 'Services/QuestionSetsService';

export const fetchQuestionSets = createAsyncThunk('questionSet/fetch', async payload => {
  const questionSet = await questionSetsService.fetchQuestionSets(payload);
  return questionSet;
});
